'use strict';

const Vue = require('vue');

const axios = require('axios');
const exclusionResultHandler = require('./delivery/exclusion-result-handler');

module.exports = (addressBookData) => {
    return {
        namespaced: true,
        state: {
            ...addressBookData,
        },
        getters: {
            getAddressById: (state) => (id) => {
                return state.addresses.find(address => address.id === id);
            },
            getSelectedAddressByType: (state) => (type) => {
                const id = type === 'shipping'
                    ? state.selectedAddresses.selectedShippingAddressId
                    : state.selectedAddresses.selectedBillingAddressId;
                return state.addresses.find(address => address.id === id);
            },
            hasSavedAddress: (state) => {
                return state.addresses.length > 0;
            }
        },
        actions: {
            updateSelectedAddress({ state, commit, rootState, rootGetters }, { addressId, type, tempAddress, recalculateTax }) {
                if (type !== 'shipping') {
                    return;
                }
                commit('delivery/setLoadingState', true, { root: true });
                const useSameAsShipping = rootGetters['details/getFieldValue']('billingAddress', 'useSameAsShipping');
                return axios({
                    method: 'post',
                    url: state.urls.setSelectedURL,
                    data: { addressId, type, tempAddress, useSameAsShipping, recalculateTax },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }
                    if (result.data.addressValidationError) {
                        commit('error/setErrorMessage', result.data.addressValidationError, { root: true });
                        commit('delivery/setLoadingState', false, { root: true });
                        return;
                    }

                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, { root: true });
                    commit('updateAddresses', result.data.addressBook);
                    exclusionResultHandler(rootState.delivery.exclusionResults, result.data.delivery.exclusionResults, commit);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                    commit('delivery/setLoadingState', false, { root: true });
                    return !result.data.delivery.exclusionResults.excludedPostal;
                });
            },
            setDefaultAddress({ state, commit }, { addressId, type }) {
                return axios({
                    method: 'post',
                    url: state.urls.setDefaultURL,
                    data: { addressId },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    commit('setSelectedAddress', type);
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            },
            deleteAddress({ state, commit }, addressId) {
                return axios({
                    method: 'post',
                    url: state.urls.deleteURL,
                    data: { addressId },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            },
            createAddress({ state, commit, dispatch }, { address, type }) {
                return axios({
                    method: 'post',
                    url: state.urls.create,
                    data: { address },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    const addressId = result.data.addressId;
                    if (addressId) {
                        commit('selectAddress', {
                            type, addressId
                        });
                        dispatch('updateSelectedAddress', {
                            type, addressId
                        });
                    }
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            },
            editAddress({ state, commit }, address) {
                return axios({
                    method: 'post',
                    url: state.urls.edit,
                    data: { address },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                    return true;
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            }
        },
        mutations: {
            selectAddress(state, { type, addressId }) {
                if (type === 'shipping') {
                    state.selectedAddresses.selectedShippingAddressId = addressId;
                    return;
                }
                state.selectedAddresses.selectedBillingAddressId = addressId;
            },
            setSelectedAddress(state, type) {
                const id = type === 'shipping'
                    ? state.selectedAddresses.selectedShippingAddressId
                    : state.selectedAddresses.selectedBillingAddressId;

                state.addresses.forEach(address => {
                    address.selected = address.id === id;
                });
            },
            updateAddresses(state, addressBook) {
                Vue.set(state, 'addresses', [...addressBook.addresses]);
                state.selectedAddresses = addressBook.selectedAddresses;
            },
            addAddress(state, newAddress) {
                const addressIndex = state.addresses.findIndex(address => newAddress.id === address.id);
                if (addressIndex) {
                    state.addresses[addressIndex] = newAddress;
                }
                state.addresses.push(newAddress);
            }
        }
    };
};
